<template>
  <div class="login-block">
    <div class="login-title">
      <h5>绑定手机</h5>
      <p>{{ errMessage }}</p>
    </div>
    <el-form
      ref="bindForm"
      class="login-form"
      :model="bindForm"
      :rules="rules"
      :show-message="false"
      size="medium"
    >
      <el-form-item prop="telNumber">
        <el-input
          v-model="bindForm.telNumber"
          maxlength="11"
          :clearable="true"
          placeholder="手机号码"
          v-on:keyup.enter.native="submitForm"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="verCode" class="pr">
        <el-input
          v-model="bindForm.verCode"
          maxlength="6"
          placeholder="短信验证码"
          v-on:keyup.enter.native="submitForm"
          autocomplete="off"
        ></el-input>
        <v-code
          class="vcode"
          session-name="TIME_ACCOUNT_LINK"
          action-path="/user-server/user/sendShortMessage"
          :action-data="actionData"
          @send="handleSend"
        ></v-code>
      </el-form-item>
    </el-form>
    <div class="link-box clearfix">
      <span class="fl primary link" @click="$emit('update', 'loginM')"
        >短信登录</span
      >
    </div>
    <div class="btn-box">
      <v-button @click="submitForm" :loading="loading">绑&emsp;定</v-button>
    </div>
  </div>
</template>

<script>
import vCode from '@/components/vCode'
import { setCookie } from '@/uitls/index.js'
import vButton from './vButton.vue'

export default {
  components: {
    vCode,
    vButton
  },
  data() {
    // 手机号码验证规则
    const telNumber = (rule, value, callback) => {
      let reg = /^1\d{10}$/
      if (!reg.test(value)) {
        callback(new Error('请正确输入手机号码'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      errMessage: '',
      // 表单
      bindForm: {
        telNumber: '',
        verCode: ''
      },
      rules: {
        telNumber: [{ validator: telNumber, trigger: 'blur' }],
        verCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '长度为6个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    actionData: function() {
      return {
        phoneNo: this.bindForm.telNumber,
        motion: 'bindPhone'
      }
    }
  },
  methods: {
    doLoading() {
      this.loading = true
    },
    doCloseLoading() {
      this.loading = false
    },
    // vcode callback
    handleSend(t) {},

    // 提交表单
    submitForm() {
      this.$refs.bindForm.validate(valid => {
        if (valid) {
          this.doLoading()
          this.$http
            .post(
              '/user-server/user/bindPhoneNo',
              {
                phoneNo: this.bindForm.telNumber,
                verificationCode: this.bindForm.verCode
              },
              {
                headers: {
                  Authorization: this.$store.state.index.dataTokn
                },
                interceptorDisabled: true
              }
            )
            .then(res => {
              this.doCloseLoading()
              if (res.data.code == 200) {
                this.$message.success(res.data.message)
                this.doSetCookie()
                // redirect to bindSuccess page
                this.$emit('update', 'bindS')
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch(err => {
              this.doCloseLoading()
              console.log(err)
            })
        } else {
          return false
        }
      })
    },
    /* set token into cookie */
    doSetCookie() {
      setCookie('accesstoken', this.$store.state.index.dataTokn, 1)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '../styles/login.scss';
</style>
<style lang="scss">
@import '../styles/form.scss';
</style>



// WEBPACK FOOTER //
// src/views/index/components/bindM.vue